(function() {
  const selectors = {
    panel: '.moe-grandchild-links',
    trigger: '[data-moechildmenu]',
    menuRoot: '.moe-megamenu__cols-continaer'
  };

  function getMenuRoot(element) {
    return element.closest(selectors.menuRoot) || document;
  }

  function setActiveTrigger(trigger) {
    const root = getMenuRoot(trigger);

    root.querySelectorAll(selectors.trigger).forEach(item => {
      item.classList.toggle('active', item === trigger);
    });

    openChildMenu(trigger.dataset.moechildmenu, root);
  }

  function openChildMenu(childMenuId, root = document) {
    root.querySelectorAll(selectors.panel).forEach(panel => {
      panel.classList.toggle('active', panel.dataset.moeChildMenuId === childMenuId);
    });
  }

  function bindTriggers(root = document) {
    root.querySelectorAll(selectors.trigger).forEach(trigger => {
      if (trigger.dataset.moeMenuBound === 'true') {
        return;
      }

      trigger.dataset.moeMenuBound = 'true';
      trigger.addEventListener('click', () => setActiveTrigger(trigger));
      trigger.addEventListener('mouseenter', () => setActiveTrigger(trigger));
    });
  }

  function resetMegaMenuContainer(root = document) {
    root.querySelectorAll(selectors.menuRoot).forEach(menuRoot => {
      const firstTrigger = menuRoot.querySelector(selectors.trigger);

      if (firstTrigger) {
        setActiveTrigger(firstTrigger);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => bindTriggers());
  document.addEventListener('shopify:section:load', event => bindTriggers(event.target));

  window.openMoeChildMenu = function(childMenuId) {
    openChildMenu(childMenuId);
  };
  window.resetMegaMenuContainer = resetMegaMenuContainer;
})();
